import { render, staticRenderFns } from "./ReceiptPreview.vue?vue&type=template&id=2228ae81&scoped=true&"
import script from "./ReceiptPreview.vue?vue&type=script&lang=js&"
export * from "./ReceiptPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPreview.vue?vue&type=style&index=0&id=2228ae81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228ae81",
  null
  
)

export default component.exports